<template lang="pug">
  main#main
    HomePage(v-show="currentPage == 'Home'")
    QuizPage(v-show="currentPage == 'Quiz'")
    AnalysisPage(v-show="currentPage == 'Analysis'")
</template>

<script>
import HomePage     from '../views/HomePage.vue'
import QuizPage     from '../views/QuizPage.vue'
import AnalysisPage from '../views/AnalysisPage.vue'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Main',
  props: {
  },
  computed: {
    ...mapState(['currentPage']),
  },
  data: () => {
    return {
    }
  },
  methods: {
    ...mapMutations([]),
  },
  components: {
    HomePage,
    QuizPage,
    AnalysisPage
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/common/';

#main {

  position: relative;
  width: 100%;
  height: auto;
  min-height: calc(var(--vh, 1vh) * 100);
  margin: 0 auto;
  z-index: 1;

  // .page {
  //   position: absolute;
  // }

  section {
    height: auto;
    min-height: calc(var(--vh, 1vh) * 100);
  }

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fefefe;
    font-weight: 600;
    padding-bottom: vwXL(8);
    @include tablet {
      padding-bottom: vw(6);
    }
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    // position: fixed;
    top: 0;
    left: 0;
    width: vwXL(34);
    height: 100%;
    background-image: url($assets + 'ruler-left_desktop.png');
    background-position: left top;
    background-repeat: repeat-y;
    background-size: 100% auto;
    pointer-events: none;
    z-index: 2;
    @include tablet {
      width: vw(28);
      background-image: url($assets + 'ruler-left.png');
    }
  }

  &::after {
    right: 0;
    left: auto;
    width: vwXL(32);
    background-image: url($assets + 'ruler-right_desktop.png');
    @include tablet {
      width: vw(27);
      background-image: url($assets + 'ruler-right.png');
    }
  }

}

</style>
